import React, { useEffect, useState } from 'react'
import { useBreadcrumbs } from '../../../core/contexts/BreadCrumbsContext';
import { useDashboards } from '../../../core/contexts/DashboardContext';
import { Dashboard, Client } from '../../../core/DashboardApi/api';
import { Grid } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import DashboardIcons from '../Common/DashboardIcons';
import { REACT_APP_PORTAL_API_URL } from '../../../KeyVariables';
import { PaymentWidget } from './Widgets/PaymentWidget';
import { AppointmentsWidget } from './Widgets/AppointmentsWidget';
import { PatientIcons } from './Widgets/PatientIcons';
import TasksWidget from '../Common/TasksWidget';
import { PatientHistoryWidget } from './Widgets/PatientHistory/PatientHistoryWidget';
import { MedicalPackageWidget } from './Widgets/MedicalPackageWidget';
import { useSearchParams } from 'react-router-dom';

export interface PatientWidgetProps {
  patientId: number;
}

function PatientDashboard() {
  const breadcrumbsContext = useBreadcrumbs();
  const { dashboards, currentDashboard } = useDashboards();
  const [searchParams] = useSearchParams();
  const patientId = searchParams.get("PatientId") ? Number(searchParams.get("PatientId")) : 0;
  
  useEffect(() => {
    const breadcrumbs = [
      { breadcrumb: 'Dashboard', path: '/' },
    ];
    breadcrumbsContext.updateBreadcrumbs(breadcrumbs);
  }, [])
  return (
    <>
      {
        dashboards.find(x => x.tag == 'patient-dashboard') && (
          <>
            <Helmet>
              <title>Dashboard</title>
            </Helmet>
            <Grid container spacing={5} sx={{ p: 1 }}>
              <Grid item xs={12} md={7}>
                <Grid container spacing={2}>
                  <PatientIcons />
                  <Grid item xs={12}>
                    <PatientHistoryWidget patientId={patientId}/>
                  </Grid>
                  <Grid item xs={12}>
                    <MedicalPackageWidget patientId={patientId}/>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={5}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TasksWidget/>
                  </Grid>
                  <Grid item xs={12}>
                    <AppointmentsWidget patientId={patientId}/>
                  </Grid>
                  <Grid item xs={12}>
                    <PaymentWidget patientId={patientId}/>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </>
        )
      }
    </>
  );
}

export default PatientDashboard